import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithStandfirstFormSectionType = {
  _initStandfirst(standfirst: string): void;
  _initStandfirstValueChanges(
    getPreviousSelectedValue: () => string | null,
  ): void;
  _buildStandfirst(): string;
  get standfirst(): string;
};

type StandfirstFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { STANDFIRST: () => string };
  destroy$: Subject<boolean>;
};

export function WithStandfirstFormSection<
  TBase extends Constructor<StandfirstFormSectionRequerimentsBase>,
>(
  baseClass: TBase,
): {
  new (...args: any[]): WithStandfirstFormSectionType;
  prototype: WithStandfirstFormSectionType;
} & TBase {
  return class WithStandfirstFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initStandfirst(standfirst: string): void {
      this.form.get(this.FORM_PATHS.STANDFIRST()).setValue(standfirst);
    }

    _initStandfirstValueChanges(
      getPreviousSelectedValue: () => string | null,
    ): void {
      this.form
        .get(this.FORM_PATHS.STANDFIRST())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousSelectedValue()) {
              this.form.get(this.FORM_PATHS.STANDFIRST()).markAsPristine();
            }
          },
        });
    }

    _buildStandfirst(): string {
      return this.form.get(this.FORM_PATHS.STANDFIRST()).value;
    }

    get standfirst(): string {
      return this.form.get(this.FORM_PATHS.STANDFIRST()).value;
    }
  };
}
